/* Registration uses the same USA lead receiver as the existing storefront forms. */
var UcgRegistrationLead = (() => {
  const endpoint = 'https://crm.nmac.bm/api/leads/usadrbrownslab';
  const siteKey = '6LdRCwEtAAAAANUKdqsSAEToVd4vWRGJ2JZSw7zM';
  const container = document.querySelector('[data-registration-captcha]');
  const feedback = document.querySelector('[data-registration-captcha-feedback]');
  const confirmed = new Map();
  let widget;
  let ready;
  let api;

  function initialize() {
    if (ready) return ready;
    ready = new Promise((resolve, reject) => {
      if (!container) { reject(new Error('Registration verification could not load. Refresh the page and try again.')); return; }
      if (!document.querySelector('script[src^="https://www.google.com/recaptcha/enterprise.js"]')) {
        const script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/enterprise.js';
        script.async = true;
        document.head.append(script);
      }
      const deadline = Date.now() + 15000;
      function render() {
        api = window.grecaptcha?.enterprise;
        if (typeof api?.render === 'function') {
          try {
            widget = api.render(container, {
              sitekey: siteKey,
              action: 'LOGIN',
              size: window.innerWidth < 380 ? 'compact' : 'normal',
            });
            if (feedback) feedback.textContent = 'Complete verification before registering.';
            resolve();
          } catch { reject(new Error('Verification could not load. Refresh the page and try again.')); }
        } else if (Date.now() >= deadline) {
          reject(new Error('Verification could not load. Check your connection or content blocker, then try again.'));
        } else {
          window.setTimeout(render, 100);
        }
      }
      render();
    }).catch(error => {
      ready = undefined;
      if (feedback) feedback.textContent = error.message;
      throw error;
    });
    return ready;
  }

  async function token() {
    await initialize();
    // Always address this widget; the page may also contain the inquiry-form CAPTCHA.
    const value = api.getResponse(widget);
    if (!value) {
      container.scrollIntoView({ block: 'center', behavior: 'smooth' });
      throw new Error('Please complete the registration verification before continuing.');
    }
    return value;
  }

  function payload(data, submissionId, captchaToken, countryLabel) {
    const countries = {
      US: 'United States', BM: 'Bermuda', CA: 'Canada', PH: 'Philippines',
      ZA: 'South Africa', UK: 'United Kingdom', AU: 'Australia', IN: 'India',
      NG: 'Nigeria', JM: 'Jamaica', TT: 'Trinidad and Tobago',
    };
    const countryCode = String(countryLabel || '').split(' ')[0];
    return {
      firstName: data.first_name,
      lastName: data.last_name,
      email: data.email,
      phone: data.phone,
      country: countries[countryCode] || '',
      how_did_you_hear: data.referral_source,
      referralNameCode: data.referral_source === 'Other' ? data.referral_other : '',
      message: [
        'Professional pricing registration request from the DBG USA eStore.',
        '',
        `Business / Practice Name: ${data.business_practice_name}`,
        `Professional Type: ${data.professional_type}`,
        ...(data.referral_source === 'Other' ? [`Referral details: ${data.referral_other}`] : []),
      ].join('\n'),
      source: 'website-lead-form',
      sourceWebsite: 'usa.drbrownslab.com',
      interests: [],
      allow_sms_messaging: false,
      sms_transactional: false,
      sms_promotional: false,
      submissionId: `shopify-registration-${submissionId}`,
      captchaToken,
    };
  }

  async function submit(data, submissionId, captchaToken, countryLabel) {
    if (confirmed.has(submissionId)) return confirmed.get(submissionId);
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        credentials: 'omit',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload(data, submissionId, captchaToken, countryLabel)),
        signal: AbortSignal.timeout(30000),
      });
      const result = await response.json().catch(() => null);
      if (!response.ok || !result || !['string', 'number'].includes(typeof result.id) || !String(result.id).trim()) {
        throw new Error('The lead request could not be confirmed. Complete verification again and retry.');
      }
      confirmed.set(submissionId, result);
      return result;
    } finally {
      if (widget !== undefined) api.reset(widget);
    }
  }

  // This container is rendered explicitly so it cannot take over another form's widget.
  if (container) void initialize().catch(() => {});
  return { token, submit };
})();
